import { AfterViewInit, Component, computed, ElementRef, inject, viewChild, ChangeDetectionStrategy } from "@angular/core";
import { CommonButtonRowWidget, CommonSelectFieldWidget, CommonTextFieldWidget, UtilityService } from "@eforall/common";
import { ReadonlyAccessWidget } from "../../../../ui/widget/readonly-access/readonly-access.widget";
import { AccApplicationInteviewFormService } from "./interview-form.service";
import { ACC_APPLICATION_INTERVIEW_RATING_VALUE_MAP } from "@interfaces";

@Component({
	selector: 'acc-application-dialog-interview-part',
	standalone: true,
	imports: [
		ReadonlyAccessWidget,
		CommonSelectFieldWidget,
		CommonButtonRowWidget,
		CommonTextFieldWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './interview.part.html',

})
export class AccApplicationDialogInterviewPart implements AfterViewInit {

	public form = new AccApplicationInteviewFormService();
	private util = inject(UtilityService);

	public saveButton = viewChild.required<ElementRef<HTMLButtonElement>>('interviewSaveForm');

	public scoreText = computed(() => {
		const accApplicationInterview = this.form.accApplicationInterview();

		if (!accApplicationInterview) return `No Interview added for the candidate yet.`;

		const ratings = [
			accApplicationInterview.valuePropositionRating,
			accApplicationInterview.coachabilityRating,
			accApplicationInterview.sustainabilityRating,
			accApplicationInterview.timeCommitmentRating,
		];


		const sum = this.util.score.calculateInterviewScore(ratings, ACC_APPLICATION_INTERVIEW_RATING_VALUE_MAP);

		// If three or more ratings are exactly 2 -> disqualify
		// If any rating is 1 -> immediate disqualify
		if (sum == 0) {
			return `The candidate does not qualify based on the interview scoring`;
		}
		else return `This candidate got a ${sum}% score in the interview.`;
	});


	async ngAfterViewInit() {
		this.form.form.setSubmitButton(
			this.saveButton(),
			async (values, changed: string[]) => {
				await this.form.accAppDialogDataService.addOrUpdateInterview(values);
			}
		)
	}


	public getDate(dateUTC: number) {
		return this.util.date.formatUTC(dateUTC, 'DOW MMM D, YYYY', 'H:MM AM EST', 'en-US');
	}

}